// extracted by mini-css-extract-plugin
export default {"alert-danger":"rgb(218, 30, 40)","wrapper":"styles_wrapper__igvPT","error":"styles_error__cljRe","errorMessage":"styles_errorMessage__9stfl"};